/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import SmallLoader from '../../../shared/components/SmallLoader';
import MonthlyLineChart from './MonthlyLineChart';
import { sortByOptions } from '../helper';

const ShowMonthDayCategoryWise = ({ dir, currentMonthData, categorisedBasedOn, isLoading,
    prevMonthData, monthDays, month1, month2, title, viewReportButton, currentlyShow }) => {
console.log(currentMonthData)
    const categorisedBasedOnRef = useRef({ categorisedBasedOn });

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])

    useEffect(() => {
        if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
            setSelectedOptions([])
        }
    }, [categorisedBasedOn])

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const currentMonthByCategory = {};
    const prevMonthByCategory = {}

    currentMonthData.forEach((item) => {
        console.log(item?.[categorisedBasedOn])
        if (item && currentMonthByCategory[item?.[categorisedBasedOn]]) {
            currentMonthByCategory[item?.[categorisedBasedOn]]?.push(item)
        } else if (item) {
            if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
                if (currentMonthByCategory?.['N/A']) {
                    currentMonthByCategory['N/A']?.push(item)
                } else {
                    currentMonthByCategory['N/A'] = item
                }
            } else {
                currentMonthByCategory[item?.[categorisedBasedOn]] = [item]
            }
        }
    });

    prevMonthData.forEach((item) => {
        
        if (item && prevMonthByCategory[item?.[categorisedBasedOn]]) {
            prevMonthByCategory[item?.[categorisedBasedOn]]?.push(item)
        } else if (item) {
            if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
                if (prevMonthByCategory?.['N/A']) {
                    prevMonthByCategory['N/A']?.push(item)
                } else {
                    prevMonthByCategory['N/A'] = item
                }
            } else {
                prevMonthByCategory[item?.[categorisedBasedOn]] = [item]
            }
        }
    });

    const currentMonthCatCount = Object.keys(currentMonthByCategory).length;
    const prevMonthCatCount = Object.keys(prevMonthByCategory).length;
    const currentMonthCat = Object.keys(currentMonthByCategory);
    const prevMonthCat = Object.keys(prevMonthByCategory);

    const max = currentMonthCatCount > prevMonthCatCount ? currentMonthCat : prevMonthCat;

    let dataToPlot = [];

    const options = []

    const reduceCallback = (acc, item) => {
        if (item?.day && acc[Number(item.day)?.toFixed(0)]) {
            acc[Number(item.day)?.toFixed(0)]?.push(item)
        } else if (Number(item.day)?.toFixed(0)) {
            acc[Number(item.day)?.toFixed(0)] = [item]
        }

        return acc;
    }

    for (let i = 0; i < max.length; i += 1) {
        const cat = max[i];
        const prevMonth = prevMonthByCategory?.[cat] ?? [];
        const currentMonth = currentMonthByCategory?.[cat] ?? [];
        let currentYearMonthMax = 0;
        let currentYearPrevMonthMax = 0;

        currentMonth?.forEach((item) => {
            currentYearMonthMax += Number(item.amount)
            currentYearPrevMonthMax += Number(item.amount)
        }
        );
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallback, {})
        const currentYearPrevMonthDayWise = prevMonth?.reduce(reduceCallback, {});

        options.push({
            value: cat, label: cat
        })

        dataToPlot.push({
            title: cat,
            currentYearMonthDayWise,
            currentYearPrevMonthDayWise,
            currentYearMonthMax: currentYearPrevMonthMax > currentYearMonthMax
                ? currentYearPrevMonthMax : currentYearMonthMax,
        })
    }

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    console.log(dataToPlot)

    return (
        <Col xs="12">
            <CardBody>
                <Card className="pb-3 show-categ-daily-sales">
                    <div className="card__title row ">
                        <h5 className="bold-text col-md-4">{title}</h5>
                        <div className="form__form-group mb-0 col-md-7" id="dvChartView">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-6">
                                    <span className="form__form-group-label font-weight-bold">
                                        {`Select ${currentlyShow?.value}`}</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={selectedOptions}
                                            options={options}
                                            clearable={false}
                                            placeholder={`Select ${currentlyShow?.value}`}
                                            className="select_filter"
                                            onChange={changeFilter}
                                            classNamePrefix="react-select"
                                            isMulti

                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <span className="form__form-group-label font-weight-bold">Sort By</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={sortBySelected}
                                            options={sortByOptions}
                                            clearable={false}
                                            placeholder="Sort By"
                                            className="select_filter"
                                            onChange={setSortBySelected}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <CardBody>
                        {isLoading ? (
                            <div
                                style={{ minHeight: '150px' }}
                                className="row align-items-center justify-content-center"
                            >
                                <SmallLoader loading={isLoading} />
                            </div>) :
                            (<>
                                {viewReportButton?.()}
                                {dataToPlot?.length ? dataToPlot?.map((category, index) => (
                                    <Row key={category.title}>
                                        <Col sm={4} md={2}><CardText>{category.title}</CardText></Col>
                                        <Col sm={8} md={10}>
                                            <MonthlyLineChart dir={dir}
                                                monthDays={monthDays}
                                                currentYearPrevMonthDayWise={category.currentYearPrevMonthDayWise}
                                                currentYearMonthDayWise={category.currentYearMonthDayWise}
                                                height={275}
                                                month1={month1}
                                                month2={month2}
                                                showTitle={false}
                                                index={index}
                                            /></Col>
                                    </Row>
                                )) : 'No data to display'}
                            </>)}
                    </CardBody>

                </Card>
            </CardBody>
        </Col>

    )
}

ShowMonthDayCategoryWise.propTypes = {
    dir: PropTypes.string.isRequired,
    prevMonthData: PropTypes.array.isRequired,
    currentMonthData: PropTypes.array.isRequired,
    monthDays: PropTypes.number.isRequired,
    month1: PropTypes.object.isRequired,
    month2: PropTypes.object.isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    categorisedBasedOn: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired
};

ShowMonthDayCategoryWise.defaultProps = {
    title: 'Month Comparison By Category',
    categorisedBasedOn: 'productCategory'
}

export default ShowMonthDayCategoryWise;
